export default __webpack_public_path__ + "acce0842681a493dc5f1d57cc99348b7.png";